export interface PermissionSet {
  [resource: string]: string[];
}

export enum Resource {
  CELL = 'CELL',
  CONSOLE = 'CONSOLE',
  CUSTOMER = 'CUSTOMER',
  DATASOURCE = 'DATASOURCE',
  EM_INSTANCE = 'EM_INSTANCE',
  INTEGRATION = 'INTEGRATION',
  SOLUTION = 'SOLUTION',
  USER = 'USER',
  MANAGEDFUSION_SYSTEM = 'MANAGEDFUSION_SYSTEM',
  MANAGEDFUSION_INTEGRATION = 'MANAGEDFUSION_INTEGRATION',
  MANAGEDFUSION_ROLE = 'MANAGEDFUSION_ROLE',
  SELFHOSTEDFUSION_INTEGRATION = 'SELFHOSTEDFUSION_INTEGRATION',
  SELFHOSTEDFUSION_SYSTEM = 'SELFHOSTEDFUSION_SYSTEM',
  ML_MODEL_DEPLOYMENT = 'ML_MODEL_DEPLOYMENT',
  ML_MODEL = 'ML_MODEL',
  SERVICE_ACCOUNTS = 'SERVICE_ACCOUNTS',
  FUSION_CONFIGURATION_PROMOTION = 'FUSION_CONFIGURATION_PROMOTION',
  COMPOSITION = 'COMPOSITION',
  TEMPLATE = 'TEMPLATE',
  SEARCH_SERVICE = 'SEARCH_SERVICE',
  SITE = 'SITE',
  SITE_ENVIRONMENT = 'SITE_ENVIRONMENT',
  TYPEAHEAD_SERVICE = 'TYPEAHEAD_SERVICE',
}

export enum Action {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  VIEW = 'VIEW',
  VIEW_ALL = 'VIEW_ALL',
  VIEW_GCP_LINKS = 'VIEW_GCP_LINKS',
  ASSIGN_CUSTOMER = 'ASSIGN_CUSTOMER',
}

export interface PermissionSetGroup {
  [group: string]: PermissionSet | { [id: string]: PermissionSet };
}

export interface PermissionContext {
  customerId: string;
  appId: string;
}
